import type { ReactNode } from 'react';
import * as React from 'react';
import { useState } from 'react';

import { MOBILE_MAIN_IDENTIFIER, type MobileMainIdentifierValues } from 'bundles/composable-page-header/constants';
import type { ToParentPage, ToSubPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';
import MobileNavigationContext, {
  useCloseMobileMenu,
} from 'bundles/composable-page-header/contexts/MobileNavigationContext';

type Props = {
  children: ReactNode;
  subPagesMap: Partial<Record<MobileMainIdentifierValues, ReactNode>>;
};
const MobileMenuConfigWrapper = ({ children, subPagesMap }: Props) => {
  const [currentView, setCurrentView] = useState<MobileMainIdentifierValues>();
  const closeMobileMenu = useCloseMobileMenu();

  const toSubPage: ToSubPage = (pageIdentity: MobileMainIdentifierValues) => {
    setCurrentView(pageIdentity);
  };

  const toParentPage: ToParentPage = (pageIdentity: MobileMainIdentifierValues) => {
    setCurrentView(pageIdentity);
  };

  const renderView = () => {
    if (currentView && currentView !== MOBILE_MAIN_IDENTIFIER.MAIN_MENU && subPagesMap[currentView]) {
      return subPagesMap[currentView];
    }
    return children;
  };

  return (
    <MobileNavigationContext.Provider value={{ toSubPage, toParentPage, closeMobileMenu }}>
      {renderView()}
    </MobileNavigationContext.Provider>
  );
};

export default MobileMenuConfigWrapper;
